import { getInitialStateFromConfig } from "helpers/form";
import { numberInRange } from "helpers/validators";
import { list } from "sources/books/timezones";

const config = {
    name: {
        // field
        label: "Название компании",
        inputProps: { name: "name" },
    },
    email: {
        // field
        label: "Эл. почта",
        inputProps: { name: "email", placeholder: "example@example.com" },
    },
    phoneNumber: {
        // field
        label: "Телефон",
        type: "phone",
        inputProps: { name: "phoneNumber" },
    },
    site: {
        // field
        label: "Сайт",
        inputProps: { name: "site" },
    },
    address: {
        // field
        label: "Адрес",
        inputProps: { name: "address" },
    },
    timezoneId: {
        // select
        label: "Часовой пояс",
        inputProps: { name: "timezoneId", autoComplete: "off" },
        url: list,
        propName: "displayName",
    },
    isDriverGeozoneControlEnabled: {
        label: "Контроль геозон в мобильном приложении",
        type: "checkbox",
        inputProps: { name: "isDriverGeozoneControlEnabled" },
    },
    driverMustBeAtPointForAction: {
        label: "Возможность отметки на точке только при нахождении в ней",
        type: "checkbox",
        inputProps: { name: "driverMustBeAtPointForAction" },
        tooltip:
            "При включении опции водитель сможет отметиться на точке только при наличии фактической/ручной даты въезда в точку и отсутствии фактической/ручной даты выезда из точки.",
    },
    driverGeozoneActionWindow: {
        label: "Временной интервал для отметки о въезде в точку",
        inputProps: { name: "driverGeozoneActionWindow", type: "time", skip: 600 },
        tooltip:
            "Водитель может отметиться о въезде в точку в течение указанного времени с момента въезда на точку. После истечения срока — отметка невозможна, даже если он на точке.",
    },
    closedPeriodIsEnabled: {
        label: "Закрытый период",
        type: "checkbox",
        inputProps: { name: "closedPeriodIsEnabled" },
    },
    closedPeriodDay: {
        label: "День закрытого периода (день месяца, от 1 до 28)",
        inputProps: { name: "closedPeriodDay", type: "text", step: "1", min: 0 },
    },
    useClosedPeriodByDate: {
        label: "Тип закрытого периода",
        inputProps: { name: "useClosedPeriodByDate" },
        type: "checkbox",
        options: [
            { label: "По дню месяца (от 1 до 28)", value: "false" },
            { label: "По конкретной дате", value: "true" },
        ],
    },
    closedPeriodDate: {
        label: "Дата закрытого периода",
        inputProps: { name: "closedPeriodDate", type: "date" },
    },
    geozoneRadius: {
        label: "Радиус геозоны по умолчанию (в м.)",
        inputProps: { name: "geozoneRadius", type: "number", step: "1", min: 0 },
    },
    itemChangePointGeozoneRadius: {
        label: "Радиус геозоны точек перецепок по умолчанию (в м.)",
        inputProps: { name: "itemChangePointGeozoneRadius", type: "number", step: "1", min: 0 },
    },
    criticalMileage: {
        label: "Критический перепробег (в км.)",
        inputProps: { name: "criticalMileage", type: "number", step: "0.1", pattern: "[0-9]+([.,][0-9]+)?", min: 0 },
    },
    bidPointVisitIgnoreDuration: {
        label: "Время учета геозоны (в мин.)",
        inputProps: { name: "bidPointVisitIgnoreDuration", type: "number", step: "1", min: 0 },
    },
    customPointVisitIgnoreDuration: {
        label: "Время учета геозоны для произвольных точек (в мин.)",
        inputProps: { name: "customPointVisitIgnoreDuration", type: "number", step: "1", min: 0 },
    },
    usesBidsApproval: {
        label: "Согласование черновиков",
        type: "checkbox",
        inputProps: { name: "usesBidsApproval" },
    },
    driverAtPointOffset: {
        label: "Корректировка периода нахождения в геозоне (в мин.)",
        inputProps: { name: "driverAtPointOffset", type: "number", step: "1", min: 0 },
    },
    wantedOutput: {
        inputProps: { name: "wantedOutput", type: "number", step: "0.01" },
    },
    minimumCarStopDuration: {
        label: 'Минимальное время остановки для "Отчета по простоям машин"',
        inputProps: { name: "minimumCarStopDuration", type: "time", skip: 600 },
    },
    minimumRefuelingDuration: {
        label: "Минимальное время заправки (в мин.)",
        inputProps: { name: "minimumRefuelingDuration", type: "number", step: "1", min: 3 },
    },
    maxPlanMileageDeviation: {
        label: "Блокировка автоматического закрытия заявки при разнице между плановым и фактическим пробегом (%)",
        inputProps: { name: "maxPlanMileageDeviation", type: "number", step: "1", min: 0, max: 100 },
    },
    minimumBidItemChangePointDuration: {
        label: "Минимальное время нахождения на точке перецепки/пересменки",
        inputProps: { name: "minimumBidItemChangePointDuration", type: "time", skip: 600 },
    },
    startBidWithSuccessSync: {
        label: "Не запускать заявку в работу без успешной синхронизации с ВИС",
        type: "checkbox",
        inputProps: { name: "startBidWithSuccessSync" },
    },
    startEmptyMileageBidWithoutSync: {
        label: "Не синхронизировать с ВИС порожнюю заявку",
        type: "checkbox",
        inputProps: { name: "startEmptyMileageBidWithoutSync" },
    },
    techSupportNumber: {
        label: "Номер тех. поддержки",
        inputProps: { name: "techSupportNumber" },
    },
    sendMobileAppCoordinates: {
        label: "Прием мобильных координат",
        type: "checkbox",
        inputProps: { name: "sendMobileAppCoordinates" },
    },
    sendCoordinatesGap: {
        label: "Промежуток времени отправки пакета координат (в секундах)",
        inputProps: { name: "sendCoordinatesGap", type: "number", step: "1", min: 30, max: 720 },
        validators: [(value, data) => (data.sendMobileAppCoordinates ? numberInRange(value, 30, 720) : "")],
    },
    saveCoordinatesInterval: {
        label: "Интервал фиксирования координат (в секундах)",
        inputProps: { name: "saveCoordinatesInterval", type: "number", step: "1", min: 1, max: 20 },
        validators: [(value, data) => (data.sendMobileAppCoordinates ? numberInRange(value, 1, 20) : "")],
    },
    suppressRefuelingUpdateRadius: {
        label: "Не обновлять план заправок до АЗС (в км.)",
        inputProps: { name: "suppressRefuelingUpdateRadius", type: "number", min: 0, max: 100 },
    },
    displayPlanLeaveDate: {
        label: "Отображать плановую дату выезда в МП Водители",
        type: "checkbox",
        inputProps: { name: "displayPlanLeaveDate" },
    },
    weightLimit: {
        label: "Ограничение на ввод веса в тоннах",
        type: "checkbox",
        inputProps: { name: "weightLimit" },
    },
    onlyNewPhotos: {
        label: "Запретить загрузку фото из галереи",
        type: "checkbox",
        inputProps: { name: "onlyNewPhotos" },
    },
    useOdometerMileage: {
        label: "Использование данных с одометра для ручного закрытия заявки",
        type: "checkbox",
        inputProps: { name: "useOdometerMileage" },
    },
    showBidParticipantsFilterSeparately: {
        label: "Переключение фильтра поиска по логисту",
        type: "checkbox",
        inputProps: { name: "showBidParticipantsFilterSeparately" },
    },
    showAllDraftsInPlanning: {
        label: "Отображать черновики в планировании",
        type: "checkbox",
        inputProps: { name: "showAllDraftsInPlanning" },
    },
    useUniqueUsersGroups: {
        label: "Запрет указания машины и колонны в нескольких группах пользователей",
        type: "checkbox",
        inputProps: { name: "useUniqueUsersGroups" },
    },
    disableEnvelopeUniquenessChecking: {
        label: "Разрешить использовать один QR код для разных конвертов заявки",
        type: "checkbox",
        inputProps: { name: "disableEnvelopeUniquenessChecking" },
    },
    distributedBidRequired: {
        label: "Ограничить создание заявок только через заказы",
        type: "checkbox",
        inputProps: { name: "distributedBidRequired" },
    },
    documentsPolicy: {
        label: "Работать с УПД",
        type: "checkbox",
        inputProps: { name: "documentsPolicy" },
    },
    doNotNotifyDriversAboutBidRefuelingsUpdated: {
        label: "Отключить отправку уведомлений водителям о планировании новых АЗС",
        type: "checkbox",
        inputProps: { name: "doNotNotifyDriversAboutBidRefuelingsUpdated" },
    },
    location: {},
    pinCode: {},
    management: {},
    accountant: {},
};

const accountantConfig = {
    position: {
        // field
        label: "Должность",
        inputProps: { name: "position" },
    },
    lastName: {
        // field
        label: "Фамилия",
        inputProps: { name: "lastName" },
    },
    firstName: {
        // field
        label: "Имя",
        inputProps: { name: "firstName" },
    },
    patronymic: {
        // field
        label: "Отчество",
        inputProps: { name: "patronymic" },
    },
    signature: {},
};

const initialState = getInitialStateFromConfig(config);
const accountantInitialState = getInitialStateFromConfig(accountantConfig);

export { config, initialState, accountantInitialState, accountantConfig };
